import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const NewsletterService = {
  getList() {
    return Http.get(`/newsletter/list`);
  }
};

export default NewsletterService;
